import EditItemComp from "./components/EditItemComp";
import LoginComp from "./components/LoginComp";
import FamilyComp from "./components/FamilyComp";
import FamilyTree from "./components/FamilyTree";
import EventListComp from './components/event/EventList'
import EventEditComp from './components/event/EventEdit'
import {InitGallery} from './components/event/Gallery'
import { InitMyInvitations as MyInvitations } from "./components/event/MyInvitations";
import { InitUpcomingEvent as UpcomingEvent } from "./components/event/UpcomingEvent";
import { InitLastUploadedFamilyMember as LastUploadedFamilyMember } from "./components/event/LastUploadedFamilyMember";
import { InitProfileComp } from "./components/proifle/ProfileComp";
import { InitNearbyFamilyMember } from "./components/event/NearbyFamilyMember";
class Main {
    constructor() {
        // tslint:disable-next-line:no-unused-expression
        new EditItemComp();
        // tslint:disable-next-line:no-unused-expression
        new LoginComp();
        // tslint:disable-next-line:no-unused-expression
        new EventListComp();
        // tslint:disable-next-line:no-unused-expression
        new EventEditComp();
        // tslint:disable-next-line:no-unused-expression
        new InitGallery();
        // tslint:disable-next-line:no-unused-expression
        new FamilyComp();
        // tslint:disable-next-line:no-unused-expression
        new MyInvitations();
        // tslint:disable-next-line:no-unused-expression
        new UpcomingEvent();
        // tslint:disable-next-line:no-unused-expression
        new LastUploadedFamilyMember();
        // tslint:disable-next-line:no-unused-expression
        new InitNearbyFamilyMember();
        // tslint:disable-next-line:no-unused-expression
        new FamilyTree('/img/family_tree/default.json' ,'/user/getUserWithConnectedUsers/');

        // tslint:disable-next-line:no-unused-expression
        new InitProfileComp();
	}
}
 // tslint:disable-next-line:no-unused-expression
new Main();



// WEBPACK FOOTER //
// ./Main.ts